import cookies from 'js-cookie';
import 'focus-visible';
import 'lazysizes';
import 'lazysizes/plugins/attrchange/ls.attrchange';

import './scss/application.scss';
import { OFF, SUBSCRIBE_SERVICE } from './config/constants';
import addClass from './utils/dom/addClass';
import click from './utils/dom/click';
import clickEvent from './utils/dom/click';
import hasClass from './utils/dom/hasClass';
import removeClass from './utils/dom/removeClass';
import { lockScroll, unlockScroll } from './utils/dom/scroll';
import formatPrice from './utils/formatPrice';
import getImage from './utils/getImage';
import { KEY_CODES, KEY_DOWN } from './utils/keys';

const FOCUSABLE_ELEMENTS = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
const ON = 'on';
const GRID = 'Grid';

let currentTab = 1;
let focusableContent = null;
let currentMenu = null;

const biggie = (displaySize) => {
  const bigClass = 'biggie-biggie-biggie';
  const gridClass = 'griddle';

  if (displaySize === 'XL') {
    addClass(document.body, bigClass);
    removeClass(document.body, gridClass);
  } else if (displaySize === GRID) {
    addClass(document.body, gridClass);
    removeClass(document.body, bigClass);
    // This is duplicated in application.js
    // Scroll to the current variant image
    const currents = [...document.querySelectorAll('.collection-grid-img.current')];
    currents.forEach((current) => {
      current.parentElement.scrollTo({
        left: current.offsetWidth * parseInt(current.dataset.index, 10),
      });
    });
  } else {
    removeClass(document.body, gridClass);
    removeClass(document.body, bigClass);
  }

  setTimeout(() => {
    window.lazySizes.autoSizer.checkElems();
  }, 450);
};

const displaySizes = () => {
  const displaySizeCookie = 'hmr-dsply-sz';
  const displaySize = cookies.get(displaySizeCookie) || GRID;
  const displayButtons = [...document.querySelectorAll('.display-size-button')];
  const displayGrid = window.HMR?.collection?.displayGrid || false;

  const onDisplaySizeChange = (event) => {
    const newDisplaySize = event.target.innerHTML;
    removeClass(document.querySelector(`.display-size-button.${ON}`), ON);
    addClass(event.target, ON);
    cookies.set(displaySizeCookie, newDisplaySize);
    biggie(newDisplaySize);
  };

  displayButtons.forEach((button) => {
    if (displayGrid && button.innerHTML === GRID) {
      addClass(button, ON);
    } else if (!displayGrid && button.innerHTML === displaySize) {
      addClass(button, ON);
    }
    button.addEventListener('click', onDisplaySizeChange);
  });

  if (displayGrid) {
    biggie(GRID);
  } else {
    biggie(displaySize);
  }

  const collections = [...document.querySelectorAll('.collection')];
  collections.forEach((el) => removeClass(el, OFF));
};

const onKeyDown = (event) => {
  const isTabPressed = event.key === KEY_CODES.TAB;

  if (event.key === KEY_CODES.ESC) {
    closeOpen();
    focusableContent[0].focus();
    return;
  }

  if (!isTabPressed) {
    return;
  }

  if (event.shiftKey) {
    currentTab = currentTab - 1 < 0 ? focusableContent.length - 1 : currentTab - 1;
  } else {
    currentTab = currentTab === focusableContent.length - 1 ? 0 : currentTab + 1;
  }

  event.preventDefault();
  focusableContent[currentTab].focus();
};

const onDomClick = (event) => {
  if (currentMenu.contains(event.target)) {
    return;
  }
  closeOpen();
  // console.info('click', currentMenu.contains(event.target), currentMenu, event.target);
};

const closeOpen = () => {
  const target = document.querySelector(`.hmr-nav .hmr-subnav.${ON}`);

  window.removeEventListener(KEY_DOWN, onKeyDown);
  document.body.removeEventListener(click(), onDomClick);
  removeClass(document.body, 'nav-open');

  if (!target) {
    return;
  }

  const elements = [...target.querySelectorAll(FOCUSABLE_ELEMENTS)];
  elements.forEach((element) => {
    element.setAttribute('tabindex', -1);
  });
  unlockScroll();
  removeClass(target, ON);
  // const header = document.querySelector('.hmr-header');
  // header.style.zIndex = 20;

  // console.info('closeOpen', target, currentMenu);
};

const manageFocus = (button, target) => {
  const elements = [...target.querySelectorAll(FOCUSABLE_ELEMENTS)];
  elements.forEach((element) => {
    element.setAttribute('tabindex', 0);
  });

  currentTab = 1;
  focusableContent = [button].concat(elements);
  focusableContent[1].focus();
  window.addEventListener(KEY_DOWN, onKeyDown);
};

const onAddToCart = async (event) => {
  const { detail } = event;
  const count = document.getElementById('cart-count');
  const current = parseInt(count.getAttribute('data-cart-count'), 10);
  const newCount = current + detail.items.length;
  count.innerHTML = `(${newCount})`;
  count.setAttribute('data-cart-count', newCount);
  addClass(count, ON);

  const request = await fetch('/cart.js');
  const response = await request.json();
  // console.info('request', response);

  const items = [];
  response.items.forEach(({ featured_image, final_line_price, product_title, quantity, url, variant_id }) => {
    const price = formatPrice(final_line_price, variant_id);

    // console.info('final_line_price', final_line_price);
    // This markup is duplicated in the header.liquid file.
    items.push(`
    <li class="hmr-cart-item">
      <a class="hmr-cart-link" href="${url}">
        <div class="hmr-cart-detail">
          <div class="hmr-cart-img">${getImage({ ...featured_image, src: featured_image.url })}</div>
          <strong>
            ${product_title}
            ${quantity > 1 ? ` x ${quantity}` : ''}
          </strong>
        </div>
        <div>${price}</div>
      </a>
    </li>
    `);
  });
  const list = document.querySelector('.hmr-cart-list');
  list.innerHTML = items.join('');

  const formattedPrice = formatPrice(response.items_subtotal_price);
  const total = document.querySelector('[data-cart-total]');
  total.innerHTML = formattedPrice;

  removeClass(document.querySelector('.hmr-cart-empty'), ON);
  addClass(document.querySelector('.hmr-cart-full'), ON);

  const button = document.getElementById('cart-toggle');
  const target = document.getElementById('hmr-cart');
  closeOpen();

  currentMenu = target;
  document.body.addEventListener(click(), onDomClick);
  addClass(target, ON);
  manageFocus(button, target);

  setTimeout(closeOpen, 3000);
};

const setupNav = () => {
  const items = [
    { button: 'menu-toggle', target: 'hmr-menu' },
    { button: 'cart-toggle', target: 'hmr-cart' },
    { button: 'search-toggle', target: 'hmr-search' },
  ];
  items.forEach((item) => {
    const button = document.getElementById(item.button);
    const target = document.getElementById(item.target);

    button.addEventListener(click(), (event) => {
      const open = hasClass(target, ON);

      if (button.tagName.toUpperCase() === 'A' && (event.metaKey || event.shiftKey)) {
        return;
      }
      event.preventDefault();
      event.stopPropagation();

      closeOpen();

      if (open) {
        return;
      }

      currentMenu = target;
      addClass(target, ON);

      // const header = document.querySelector('.hmr-header');
      // header.style.zIndex = 1000;
      addClass(document.body, 'nav-open');
      manageFocus(button, target);
      lockScroll();
      document.addEventListener(click(), onDomClick);
    });
  });

  window.addEventListener('add-to-cart', onAddToCart);
  [...document.querySelectorAll('.hmr-menu-products-list-wrap')].forEach((listWrap) => {
    const list = listWrap.querySelector('ul');
    const previous = listWrap.querySelector('.hmr-menu-products-nav--prev');
    const next = listWrap.querySelector('.hmr-menu-products-nav--next');
    const kids = list.querySelectorAll('li');

    if (kids.length > 9) {
      const onScroll = (event) => {
        const { target } = event;
        let atSnappingPoint = target.scrollLeft % target.offsetWidth === 0;
        let timeout = atSnappingPoint ? 0 : 150;

        clearTimeout(target.scrollTimeout);

        target.scrollTimeout = setTimeout(() => {
          const index = Math.round(target.scrollLeft / kids[0].offsetWidth);
          // console.info("index", index, previous, next);

          if (index === 0) {
            removeClass(previous, ON);
          } else {
            addClass(previous, ON);
          }

          if (index === kids.length - 9) {
            removeClass(next, ON);
          } else {
            addClass(next, ON);
          }
        }, timeout);
      };

      const move = (direction) => {
        // console.info(list.scrollLeft);
        list.scrollTo({ left: list.scrollLeft + kids[0].offsetWidth * direction, behavior: 'smooth' });
      };
      next.addEventListener(clickEvent(), () => {
        move(1);
      });
      previous.addEventListener(clickEvent(), () => {
        move(-1);
      });

      list.addEventListener('scroll', onScroll);

      addClass(list, 'scrolling');
      addClass(next, ON);
    }
  });

  // Do some special stuff on the search page
  if (!window.location.pathname.startsWith('/search')) {
    return;
  }

  const clear = document.querySelector('.hmr-search-field-clear');
  if (clear) {
    clear.addEventListener(click(), () => {
      const parent = clear.parentElement;

      removeClass(parent, 'searched');
      parent.querySelector('input').value = '';
      parent.removeChild(clear);
      window.location.assign('/collections/shop');
    });
  }
};

const loadNav = async () => {
  const toSelector = '#facets-loaded';
  const to = document.querySelector(toSelector);

  if (!to) {
    return;
  }

  const url = `/collections/${to.dataset.collection}`;
  const fromSelector = '#facets';
  const cached = sessionStorage[url];

  if (cached) {
    return (to.innerHTML = cached);
  }

  const request = await fetch(url);
  const text = await request.text();
  const parser = new DOMParser();
  const doc = parser.parseFromString(text, 'text/html');
  sessionStorage[url] = to.innerHTML = doc.querySelector(fromSelector).innerHTML;
};

const setupSubscribe = () => {
  const button = document.querySelector('.hmr-subscribe-button');
  if (!button) {
    return;
  }

  const bg = document.getElementById('subscribe-overlay-background');
  const close = document.getElementById('subscribe-overlay-close');
  const form = document.getElementById('subscribe-overlay');

  form.querySelector('form').addEventListener('submit', async (event) => {
    event.preventDefault();
    const firstName = document.getElementById('hmr-subscribe-first-name');
    const lastName = document.getElementById('hmr-subscribe-last-name');
    const email = document.getElementById('hmr-subscribe-email');
    const phone = document.getElementById('hmr-subscribe-phone');
    const country = document.getElementById('hmr-subscribe-country');
    const button = event.target.querySelector('button[type="submit"]');

    const data = {
      email: email.value,
      firstName: firstName.value,
      lastName: lastName.value,
      phone: phone.value,
      country: country.value,
      consent: true,
    };

    // console.info(data);
    button.setAttribute('disabled', 'disabled');

    const request = await fetch(`${SUBSCRIBE_SERVICE}subscribe`, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const response = await request.json();

    button.removeAttribute('disabled');

    if (response.ok) {
      const success = document.getElementById('subscribe-form-success');
      success.innerHTML = '<div style="font-size: 10px;">Thanks for subscribing.</div>';
      success.focus();

      focusableContent = [...success.parentElement.querySelectorAll(FOCUSABLE_ELEMENTS)];
      currentTab = 0;
    } else {
      alert('There was an error signing up.\nPlease reach out to customer service.');
    }
  });

  const onKeyDown = (event) => {
    const isTabPressed = event.key === KEY_CODES.TAB;

    if (event.key === KEY_CODES.ESC) {
      closeSubscribe();
      button.focus();
      return;
    }

    if (!isTabPressed) {
      return;
    }

    if (event.shiftKey) {
      currentTab = currentTab - 1 < 0 ? focusableContent.length - 1 : currentTab - 1;
    } else {
      currentTab = currentTab === focusableContent.length - 1 ? 0 : currentTab + 1;
    }

    event.preventDefault();
    focusableContent[currentTab].focus();
  };

  const closeSubscribe = () => {
    const elements = [...form.querySelectorAll(FOCUSABLE_ELEMENTS)];
    elements.forEach((element) => {
      element.setAttribute('tabindex', -1);
    });

    window.removeEventListener(KEY_DOWN, onKeyDown);
    close.removeEventListener(click(), closeSubscribe);
    bg.removeEventListener(click(), closeSubscribe);
    unlockScroll();
    removeClass(bg, ON);
    removeClass(form, ON);
  };

  const openSubscribe = () => {
    lockScroll();
    addClass(bg, ON);
    addClass(form, ON);

    const elements = [...form.querySelectorAll(FOCUSABLE_ELEMENTS)];
    elements.forEach((element) => {
      element.setAttribute('tabindex', 0);
    });

    currentTab = 1;
    focusableContent = elements;
    focusableContent[0].focus();

    close.addEventListener(click(), closeSubscribe);
    bg.addEventListener(click(), closeSubscribe);
    window.addEventListener(KEY_DOWN, onKeyDown);
  };

  button.addEventListener('click', openSubscribe);
};

const application = () => {
  displaySizes();
  setupNav();
  loadNav();
  setupSubscribe();

  addClass(document.body, 'loaded');
};

application();

// A custom country picker based on the recommended docs here
// https://shopify.dev/docs/themes/markets/multiple-currencies-languages#javascript-submission-of-the-localization-form
class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: document.querySelector('.country-modal'),
      background: document.getElementById('country-modal-overlay-background'),
      close: document.getElementById('country-modal-close'),
    };
    this.elements.button.addEventListener('click', this.openModal.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.elements.close.addEventListener('click', this.closeModal.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.elements.panel
      .querySelectorAll('a')
      .forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  closeModal() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
    removeClass(this.elements.panel, 'on');
    removeClass(this.elements.background, 'on');
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.closeModal();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
    this.closeModal();
  }

  openModal() {
    document.getElementById('menu-toggle').click();
    this.elements.panel.toggleAttribute('hidden');
    addClass(this.elements.panel, 'on');
    addClass(this.elements.background, 'on');
    this.elements.button.setAttribute(
      'aria-expanded',
      (this.elements.button.getAttribute('aria-expanded') === 'false').toString(),
    );
    this.elements.panel.querySelector('a').focus();
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.closeModal();
    }
  }
}

customElements.define('localization-form', LocalizationForm);

window.addEventListener('scroll', function () {
  const body = document.querySelector('body');
  if (window.scrollY > 50) {
    addClass(body, 'scrolled');
  } else {
    removeClass(body, 'scrolled');
  }
});
// Free shipping banner
const addBanner = () => {
  const banner = document.querySelector('.ge-free-shipping-container');
  if (banner) {
    document.querySelector('main').appendChild(banner);
    addClass(document.body, 'has-banner');
  }
};

const freeShippingBanner = document.querySelector('.ge-free-shipping-container');
if (freeShippingBanner) {
  addBanner();
} else {
  // Options for the observer (which mutations to observe)
  const config = { childList: true, subtree: true };

  // Callback function to execute when mutations are observed
  const callback = function (mutationsList, observer) {
    for (let mutation of mutationsList) {
      if (mutation.type === 'childList') {
        for (let node of mutation.addedNodes) {
          if (node.nodeType === Node.ELEMENT_NODE && node.matches('.ge-free-shipping-container')) {
            // Stop observing the body
            observer.disconnect();
            addBanner();
          }
        }
      }
    }
  };

  // Create an observer instance linked to the callback function
  const observer = new MutationObserver(callback);

  // Start observing the document body for configured mutations
  observer.observe(document.body, config);
}

class HMRSelect extends HTMLElement {
  constructor() {
    super();
    this.connectedTo = this.dataset.connectedTo;
    this.elements = {
      select: this.querySelector('select'),
      options: this.querySelectorAll('.option'),
    };

    if (!this.elements.select) {
      return;
    }
    this.value = this.elements.select.value;
    this.elements.select.addEventListener('change', this.onChange.bind(this));
    this.render();

    // Keyboard-only focus outline support
    this._lastInputWasKeyboard = false;
    document.addEventListener('keydown', this._onKeyDownInput.bind(this), true);
    document.addEventListener('mousedown', this._onMouseDownInput.bind(this), true);
    this.elements.select.addEventListener('focus', this._onFocus.bind(this));
    this.elements.select.addEventListener('blur', this._onBlur.bind(this));
  }

  _onKeyDownInput(e) {
    if (e.key === 'Tab' || e.key === 'Shift') {
      this._lastInputWasKeyboard = true;
    }
  }

  _onMouseDownInput() {
    this._lastInputWasKeyboard = false;
  }

  _onFocus() {
    if (this._lastInputWasKeyboard) {
      this.classList.add('select-keyboard-focus');
    }
  }

  _onBlur() {
    this.classList.remove('select-keyboard-focus');
  }

  onChange(event) {
    this.value = event.target.value;

    if (this.connectedTo) {
      const connectedTo = document.getElementById(this.connectedTo)?.closest('hmr-select');
      connectedTo?.update(this.value);
    }
    this.render();
  }

  render() {
    this.elements.options.forEach((option) => {
      if (option.dataset.value === this.value) {
        addClass(option, 'on');
      } else {
        removeClass(option, 'on');
      }
    });
  }

  update(value) {
    this.value = value;
    this.elements.select.value = value;
    this.render();
  }
}

customElements.define('hmr-select', HMRSelect);
